import { ChangeEvent } from 'react';
import Select from '../../../components/Select';
import { ListType, SelectedOptionType } from '../types';

interface RoleAndSindFilterInterface {
  selectedRole: SelectedOptionType;
  handleRoleChange: (event: ChangeEvent<HTMLSelectElement>) => void ;
  isLoading: boolean;
  isRolesSelectDisabled: boolean;
  rolesList: ListType;
  selectedSind: SelectedOptionType;
  handleSindChange: (event: ChangeEvent<HTMLSelectElement>) => void ;
  sindList: ListType;
}

export default function RoleAndSindFilter({
  selectedRole,
  handleRoleChange,
  isLoading,
  isRolesSelectDisabled,
  rolesList,
  selectedSind,
  handleSindChange,
  sindList,
}: RoleAndSindFilterInterface) {
  return (
    <>
      <div>
        <h1>Selecione um cargo</h1>
        <Select
          value={selectedRole.value}
          onChange={handleRoleChange}
          disabled={isLoading || isRolesSelectDisabled}
        >
          <option value="Todos">
                        Todos
          </option>
          {rolesList.map((role) => (
            <option key={role.value} value={role.value}>
              {role.label}
            </option>
          ))}
        </Select>
      </div>

      <div>
        <h1>Selecione uma sessão</h1>
        <Select
          value={selectedSind.value}
          onChange={handleSindChange}
          disabled={isLoading}
        >
          <option value="Todos">
                        Todos
          </option>
          {sindList.map((sind) => (
            <option key={sind.value} value={sind.value}>
              {sind.label}
            </option>
          ))}
        </Select>
      </div>
    </>
  );
}
